export const updateMiniSiteStyle = theme => ({
    contentAll: {
        [theme.breakpoints.up('sm')]: {
            height: 'calc(100vh - 64px)'
        },
        overflow: 'auto'
    },
    root: {
        width: '100%',
        margin: 'auto'
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
    },
    backgroundDiv: {
        // borderTop: '1px',
        // borderTopColor: theme.palette.action.selected,
        // borderTopStyle: 'solid', 
        borderBottom: '2px',
        borderBottomColor: theme.palette.primary.dark,
        borderBottomStyle: 'solid',
        width: '100%'
    },
    backgroundMiddle: {
        margin: 'auto',
        paddingLeft: 5
    },
    marginTitle: {
        marginBottom: 10
    },
    marginSeccions: {
        marginBottom: 5
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
})